import AbstractSystem from "../all/AbstractSystem";
import logger from 'src/utils/logger/logger';

class PolaroidSystem extends AbstractSystem {
    constructor() {
        super();
        this.device = undefined;
        this.document = undefined;
    }

    exit() {
    	logger.debug("[Polaroid]: System exit");
    	window.AndroidPlayerInterface.close();
        window.close();
    }

    hasMouse() {
        return true;
    }

    hasFixedKeyboard() {
        return true;
    }

    getDisplayResolution() {
        //the display resolution in workstation are 1280p and 1080p
        const config = window.config;
        var resolution1080p = config.get("device.workstation.1080p", false);
        if (resolution1080p) {
            return {
                width: 1920,
                height: 1080
            };
        }
        return {
            width: 1280,
            height: 720
        };
    }

    supportSSL() {
        return true;
    }

    redraw(element) {
        return false;
    }
}

export default PolaroidSystem;



// WEBPACK FOOTER //
// ./src/devices/polaroid/System.js